import * as React from 'react';
import { getAuctionsNearMePageUrl } from '@/utils/urls';
import { H6 } from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styled from 'styled-components';

type Props = {
    displayName: string;
    geoAreaID: number;
};

const RelatedGeoAreaCard = ({ displayName, geoAreaID }: Props) => {
    const link = getAuctionsNearMePageUrl({
        geoAreaId: geoAreaID,
        geoAreaName: displayName,
    });
    return (
        <GeoRelatedAreaATagWrapper>
            <GeoRelatedAreaATag
                route
                secondary
                to={link}
            >
                <GeoRelatedAreaItemTitle>{displayName}</GeoRelatedAreaItemTitle>
            </GeoRelatedAreaATag>
        </GeoRelatedAreaATagWrapper>
    );
};

export default React.memo<Props>(RelatedGeoAreaCard);

const GeoRelatedAreaATagWrapper = styled.div`
    margin-right: 8px;
    margin-bottom: 8px;
`;

const GeoRelatedAreaATag = styled(Link)`
    display: flex;
    text-decoration: none;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.black};
    border: ${({ theme }) => `1px solid  ${theme.colors.grey400}`};
    border-radius: 2px;

    &:hover {
        text-decoration: none;
        background-color: ${({ theme }) => theme.colors.grey500};
        span,
        h6 {
            color: ${({ theme }) => theme.colors.blue200};
        }
    }
`;

const GeoRelatedAreaItemTitle = styled(H6)`
    color: inherit;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    padding: 11px 15px;

    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        padding: 3px 10px;
    }
`;
